import { render, staticRenderFns } from "./PenSelector.vue?vue&type=template&id=3bb48eea&scoped=true&lang=pug"
import script from "./PenSelector.vue?vue&type=script&lang=ts"
export * from "./PenSelector.vue?vue&type=script&lang=ts"
import style0 from "./PenSelector.vue?vue&type=style&index=0&id=3bb48eea&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb48eea",
  null
  
)

export default component.exports